import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [
        'checkbox',
        'errorContainer',
        'errorMessageMax',
        'errorMessageMin',
        'removeCount',
        'counter',
    ];

    static values = {
        min: { type: Number, default: 1 },
        max: { type: Number, default: 30 },
    };

    connect() {
        this.validateInitialState();
    }

    fieldValueChanged(event) {
        const field = event.target;

        if (field.value.length > 0) {
            field.classList.remove('remove-error');
            field.classList.remove('is-invalid');

            const parent = field.closest('.form-group');
            const errorMessage = parent.querySelector('.form-error-message');

            if ('email' === field.type && document.querySelector('#kick_box_message')) {
                field.classList.remove('is-risky');
                field.classList.remove('email-status-risky');
                field.classList.remove('email-status-unknown');
                field.classList.remove('email-status-undeliverable');
                document.querySelector('#kick_box_message').textContent = '';
            }

            if (errorMessage) {
                errorMessage.remove();
            }
        }
    }

    validateInitialState() {
        if (!this.hasCheckboxTarget) {
            return;
        }

        const checkedCount = this.checkboxTargets.filter(cb => cb.checked).length;

        if (this.hasCounterTarget) {
            this.counterTarget.textContent = checkedCount;
        }

        if (checkedCount < this.minValue || checkedCount > this.maxValue) {
            this.disableSubmit();
        } else {
            this.enableSubmit();
        }
    }

    validateBeforeSubmit(event) {
        if (!this.hasCheckboxTarget) {
            return;
        }

        const checkedCount = this.checkboxTargets.filter(cb => cb.checked).length;

        if (checkedCount < this.minValue || checkedCount > this.maxValue) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.checkForSelectedLimit();
            return false;
        }

        return true;
    }

    checkForSelectedLimit() {
        if (!this.hasCheckboxTarget) return;

        const checkedCount = this.checkboxTargets.filter(cb => cb.checked).length;

        if (this.hasCounterTarget) {
            this.counterTarget.textContent = checkedCount;
        }

        if (this.hasErrorContainerTarget) {
            this.errorContainerTarget.style.display = 'none';
        }
        if (this.hasErrorMessageMaxTarget) {
            this.errorMessageMaxTarget.style.display = 'none';
        }
        if (this.hasErrorMessageMinTarget) {
            this.errorMessageMinTarget.style.display = 'none';
        }

        if (checkedCount < this.minValue) {
            if (this.hasErrorContainerTarget && this.hasErrorMessageMinTarget) {
                this.errorContainerTarget.style.display = 'block';
                this.errorMessageMinTarget.style.display = 'inline';
            }
            this.disableSubmit();
        } else if (checkedCount > this.maxValue) {
            if (this.hasErrorContainerTarget && this.hasErrorMessageMaxTarget) {
                this.errorContainerTarget.style.display = 'block';
                this.errorMessageMaxTarget.style.display = 'inline';

                if (this.hasRemoveCountTarget) {
                    this.removeCountTarget.textContent = checkedCount - this.maxValue;
                }
            }
            this.disableSubmit();
        } else {
            this.enableSubmit();
        }
    }

    disableSubmit() {
        const submitButton = document.querySelector('button[type="submit"]');
        if (submitButton) {
            submitButton.disabled = true;
            submitButton.classList.add('opacity-50');
        }
    }

    enableSubmit() {
        const submitButton = document.querySelector('button[type="submit"]');
        if (submitButton) {
            submitButton.disabled = false;
            submitButton.classList.remove('opacity-50');
        }
    }

    tomselectDropdownFieldValueChanged(event) {
        const field = event.target;

        if (field.value.length > 0) {
            const parent = field.closest('.form-group');
            const errorMessage = parent.querySelector('.form-error-message');
            const singleElement = parent.querySelector('.ts-wrapper');

            if (singleElement) {
                singleElement.classList.remove('is-invalid');
            }

            if (field) {
                field.classList.remove('is-invalid');
            }

            if (errorMessage) {
                errorMessage.remove();
            }
        }
    }

    phoneFieldValueChanged(event) {
        const field = event.target;

        if (field.value.length > 0) {
            field.classList.remove('is-invalid');
            field.classList.add('phone-input-valid');

            const parent = field.closest('.form-group');
            const errorMessage = parent.querySelector('.form-error-message');

            if (errorMessage) {
                errorMessage.remove();
            }
        }
    }
}
